import { useEffect } from 'react';

const SwipeHandler = ({ onSwipeUp, onSwipeDown, threshold = 50 }) => {
  useEffect(() => {
    let touchStartY = 0;
    let touchEndY = 0;
    
    const handleTouchStart = (e) => {
      touchStartY = e.targetTouches[0].clientY;
    };
    
    const handleTouchMove = (e) => {
      touchEndY = e.targetTouches[0].clientY;
    };
    
    const handleTouchEnd = () => {
      const swipeDistance = touchStartY - touchEndY;
      
      if (swipeDistance > threshold) {
        // Swiped up
        onSwipeUp && onSwipeUp();
      } else if (swipeDistance < -threshold) {
        // Swiped down
        onSwipeDown && onSwipeDown();
      }
      
      // Reset values
      touchStartY = 0;
      touchEndY = 0;
    };
    
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });
    
    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [onSwipeUp, onSwipeDown, threshold]);
  
  return null;
};

export default SwipeHandler;